import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import apiFetch from 'utils/apiFetch';
import Navbar from 'components/Navbar';
import { ROUTE_MAIN_PAGE } from 'constants/urls';
import { UserProfilesWrapper, Text, ButtonMain } from './styles';

class CancelDeletionAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
      dialogTitle: '',
      dialogText: '',
    };
  }

  componentDidMount() {
    const {
      setBreadcrumb,
      literals,
    } = this.props;

    const breadcrumb = [
      {
        color: '#ffffff',
        text: literals.title,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
  }

  goHome = () => {
    const {
      history,
      goHome,
    } = this.props;

    goHome();
    history.push(ROUTE_MAIN_PAGE);
  }

  handleCancelDeletion = () => {
    const { literals } = this.props;
    apiFetch('POST', { endPoint: 'users/cancel-deletion' })
      .then((response) => {
        if (response.success) {
          this.setState({ dialogOpen: true, dialogTitle: literals.cancelled, dialogText: literals.deletionAccountHasBeenCancelled });
        } else {
          this.setState({ dialogOpen: true, dialogTitle: literals.error, dialogText: literals.errorDeletion });
        }
      });
  }

  handleCloseDialog = () => {
    this.setState({ dialogOpen: false });
    this.goHome();
  }

  render() {
    const { color, literals } = this.props;
    const { dialogOpen, dialogTitle, dialogText } = this.state;
    return (
      <UserProfilesWrapper color={color}>
        <Navbar />
        <Text>{literals.text}</Text>
        <ButtonMain onClick={this.handleCancelDeletion}>{literals.cancel}</ButtonMain>
        <Dialog
          open={dialogOpen}
          onClose={this.handleCloseDialog}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>{dialogTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {dialogText}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDialog} color='primary'>
              {literals.close}
            </Button>
          </DialogActions>
        </Dialog>
      </UserProfilesWrapper>
    );
  }
}

CancelDeletionAccount.propTypes = {
  literals: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  goHome: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default CancelDeletionAccount;



// WEBPACK FOOTER //
// ./src/routes/CancelDeletionAccount/components/CancelDeletionAccount.jsx